import React from "react";
import HomePageStore from "../HomePageStore";
import { observer, inject } from "mobx-react";
import DiscoverAndBuildTab from "./DiscoverAndBuildTab";

export interface DiscoverAndBuildTabDesktopProps {}

interface InjectedProps extends DiscoverAndBuildTabDesktopProps {
  homePageStore: HomePageStore;
}
const DiscoverAndBuildTabDesktop: React.SFC<DiscoverAndBuildTabDesktopProps> = (
  props
) => {
  const { homePageStore } = props as InjectedProps;
  const { discoverAndBuild } = homePageStore.homePageContent.response;
  return (
    <div className="subaru_tab_items">
      <DiscoverAndBuildTab
        tabIcon={discoverAndBuild.sedansAndHatchbackIcon}
        tabImage={discoverAndBuild.sedansAndHatchbackImageLg}
        tabName="sedansAndHatchbackVariants"
        tabTitle={discoverAndBuild.sedansAndHatchbackTitle}
        tabMobile={false}
        tabDisclaimer={discoverAndBuild.sedansAndHatchbackDisclaimer}
      />

      <DiscoverAndBuildTab
        tabIcon={discoverAndBuild.suVsIcon}
        tabImage={discoverAndBuild.suVsImageLg}
        tabName="suvVariants"
        tabTitle={discoverAndBuild.suvTitle}
        tabMobile={false}
        tabDisclaimer={discoverAndBuild.suVsDisclaimer}
      />

      <DiscoverAndBuildTab
        tabIcon={discoverAndBuild.performanceIcon}
        tabImage={discoverAndBuild.performanceImageLg}
        tabName="performanceVariants"
        tabTitle={discoverAndBuild.performanceTitle}
        tabMobile={false}
        tabDisclaimer={discoverAndBuild.performanceDisclaimer}
      />

      <DiscoverAndBuildTab
        tabIcon={discoverAndBuild.hybridsIcon}
        tabImage={discoverAndBuild.hybridsImageLg}
        tabName="hybridVariants"
        tabTitle={discoverAndBuild.hybridTitle}
        tabMobile={false}
        tabDisclaimer={discoverAndBuild.hybridsDisclaimer}
      />
    </div>
  );
};

export default inject("homePageStore")(observer(DiscoverAndBuildTabDesktop));
